import PlayableDemo from './PlayableDemo';

export default {
  'playable-demo': PlayableDemo,
};
